import { IAuditEventData, UserSignInAuditSnapshotV1 } from 'api'
import { Box } from 'cs-kevlar-react'
import React from 'react'
import { DetailField } from './DetailField'
import { UnavailableDetails } from './UnavailableDetails'
import { useDetailStyles } from './useDetailStyles'
import { resolveEventData } from './utils'

interface UserSignInDetailsProps {
  eventData: IAuditEventData
}

export const UserSignInDetails: React.FunctionComponent<UserSignInDetailsProps> = ({
  eventData,
}) => {
  const signInSnapshot = resolveEventData<UserSignInAuditSnapshotV1>(
    eventData,
    nameof<UserSignInAuditSnapshotV1>(),
  )

  if (!signInSnapshot) return <UnavailableDetails />

  const classes = useDetailStyles()

  return (
    <React.Fragment>
      {signInSnapshot && (
        <Box className={classes.fieldsContainer}>
          <DetailField label="Agency ID" original={signInSnapshot.agencyId} />
          <DetailField label="Domain" original={signInSnapshot.domain} />
          <DetailField label="Username" original={signInSnapshot.username} />
          <DetailField label="Result" original={signInSnapshot.result} />
          <DetailField
            label="Federal Authentication"
            original={signInSnapshot.isFedAuth.toString()}
          />
        </Box>
      )}
    </React.Fragment>
  )
}
